module.exports = __webpack_public_path__ + "static/media/team_work.59feefbd.svg";